import { render, staticRenderFns } from "./BillingManagement.vue?vue&type=template&id=6c7539e1&scoped=true"
import script from "./BillingManagement.vue?vue&type=script&lang=js"
export * from "./BillingManagement.vue?vue&type=script&lang=js"
import style0 from "./BillingManagement.vue?vue&type=style&index=0&id=6c7539e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7539e1",
  null
  
)

export default component.exports